import React from 'react';
import {AutocompleteArrayInput, ReferenceArrayInput, required, TextInput} from 'react-admin';
import {Grid} from '@material-ui/core'


const MerchantGroupFields = (props) => {
    return (
        <React.Fragment>
            <Grid item xs={12} sm={6}>
                <TextInput source="name" {...props} validate={required()}/>
            </Grid>
            <Grid item xs={12} sm={6}>
                <ReferenceArrayInput source="merchantIds" reference="merchants"{...props}
                                     validate={required()}>
                    <AutocompleteArrayInput/>
                </ReferenceArrayInput>
            </Grid>
        </React.Fragment>
    )
}
export default MerchantGroupFields